import React, { Dispatch, useState } from 'react'

type SwitchPropTypes = {
    buttonState: boolean;
    setButtonState: Dispatch<React.SetStateAction<boolean>>
}

const Switch = (props: SwitchPropTypes) => {

    return (
        <div className={`switch-wrapper`}>
            <span style={{color: props.buttonState ? 'gray' : 'var(--text-color)'}}>voice command</span>
            <div className={`switch-base`} onClick={(e) => props.setButtonState(prevState => !prevState)}>
                <div className={`switch-button`} style={{ left: props.buttonState ? 'calc(100% - var(--_button-height))' : '0' }}></div>
            </div>
            <span style={{color: props.buttonState ? 'var(--text-color)' : 'gray'}}>text command</span>
        </div>
    )
}

export default Switch